import React from 'react';
import { connect } from 'react-redux';
import HeadTitle from './HeadTitle/HeadTitle';
import Navigation from './Navigation/Navigation';
import WeekSelectContainer from './DaySelect/DaySelectContainer';
import DayHead from './DayHead/DayHead';
import CtHead from './CtHead/CtHead';
import './Head.css';
// todo - revise props

function Head({ currentDayId, startDayId, columns }) {
  // todo - temp solution
  const days = [];
  for (let i = 0; i < columns; i += 1) {
    days.push(
      <DayHead
        key={i}
        weekdayId={i}
        currentDayId={currentDayId}
        startDayId={startDayId}
      />
    );
  }

  return (
    <div id="program-head">
      <CtHead />
      <div id="head-top">
        <HeadTitle />
        <Navigation />
        <WeekSelectContainer />
      </div>
      <div id="head-days">{days}</div>
    </div>
  );
}

const mapStateToProps = state => ({
  currentDayId: state.navigation.currentDayId,
  startDayId: state.navigation.startDayId,
  columns: state.navigation.columns
});

// todo - quick connect implementation - revise
export default connect(mapStateToProps)(Head);



// WEBPACK FOOTER //
// ./src/components/App/Program/Head/Head.js